export function hasAnyPermission(
  check: (permission: string) => boolean,
  required: string | string[] | undefined,
): boolean {
  if (!required) return true
  return Array.isArray(required) ? required.some(check) : check(required)
}
